import { render, staticRenderFns } from "./EditEventModal.vue?vue&type=template&id=79d822b2&"
import script from "./EditEventModal.vue?vue&type=script&lang=js&"
export * from "./EditEventModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports